import axios from 'axios';
import { setAuthHeader } from 'Services/utils';
import { programmingInterests } from './interestsFilter.js';

const INTERESTS_API_URL = process.env.REACT_APP_ACTIONS_API_URL;

const setInterestsApiUrl = (userId) => {
  return `${INTERESTS_API_URL}/v2/actions/rbtv/users/${userId}/interests`;
};

const setInterestsOptoutApiUrl = (userId) => {
  return `${INTERESTS_API_URL}/v2/actions/rbtv/users/${userId}/interests-optout`;
};

const getInterestsStatus = async (userId, userToken) => {
  try {
    const interests = await axios.get(`${setInterestsApiUrl(userId)}`, {
      ...setAuthHeader(userToken),
    });
    const hasInterests = interests?.data?.meta?.totalCount > 0;
    if (hasInterests) return true;
    // users who don't have interests may have opted out
    // they should have an "interests-optout" action type
    const optout = await axios.get(`${setInterestsOptoutApiUrl(userId)}`, {
      ...setAuthHeader(userToken),
    });
    const hasOptout = optout?.data?.meta?.totalCount > 0;
    if (hasOptout) return true;
    return false;
  } catch (err) {
    throw err;
  }
};

const getInterests = async (userId, userToken) => {
  const { data } = await axios.get(`${setInterestsApiUrl(userId)}`, {
    ...setAuthHeader(userToken),
  });
  const interests = Object.keys(data.items);
  const validInterests = interests.filter((interest) =>
    programmingInterests.includes(interest)
  );
  return validInterests;
};

const saveInterestsArray = async (additions, userId, userToken) => {
  let saved = [];
  for (const addition of additions) {
    const interest = await saveInterest(addition, userId, userToken);
    saved.push(interest);
  }
  return saved;
};

const saveInterest = (addition, userId, userToken) => {
  return axios.post(
    `${setInterestsApiUrl(userId)}/${encodeURIComponent(addition)}`,
    null,
    { ...setAuthHeader(userToken) }
  );
};

// replace saveInterestsArray with this once RBMN-26658 is deployed
// const saveInterestsArray = (additions, userId, userToken) => {
//   return Promise.all(
//     additions.map(addition => {
//       return axios.post(
//         `${setInterestsApiUrl(userId)}/${encodeURIComponent(addition)}`,
//         null,
//         { ...setAuthHeader(userToken) }
//       );
//     })
//   );
// };

const deleteInterestsArray = (deletions, userId, userToken) => {
  return Promise.all(
    deletions.map((deletion) => {
      return deleteInterest(deletion, userId, userToken);
    })
  );
};

const deleteInterest = (deletion, userId, userToken) => {
  return axios.delete(
    `${setInterestsApiUrl(userId)}/${encodeURIComponent(deletion)}`,
    { ...setAuthHeader(userToken) }
  );
};

// users who opt out of interests should not be presented with the interests screen
// mark these users by posting an "optout" itemId under the "interests-optout" actionType
const setOptout = (optout = false, userId, userToken) => {
  if (optout) {
    return axios.post(
      `${setInterestsOptoutApiUrl(userId)}/${encodeURIComponent('optout')}`,
      null,
      { ...setAuthHeader(userToken) }
    );
  } else {
    // we should delete the "optout" itemId if a user adds interests
    return axios.delete(
      `${setInterestsOptoutApiUrl(userId)}/${encodeURIComponent('optout')}`,
      { ...setAuthHeader(userToken) }
    );
  }
};

export {
  deleteInterestsArray,
  deleteInterest,
  getInterests,
  getInterestsStatus,
  saveInterest,
  saveInterestsArray,
  setOptout,
};
